import axios from "axios";
import { ApiException } from "@/services/api/ApiExceptions";
import {
  IProcessDocumentTypeId,
  IProcessDocumentType,
  IProcessDocumentId,
  ICreateDocument
} from "@/store/types/document-type";

export const copyGDocDocument = ({
  processId,
  documentTypeId,
  documentModelId
}: IProcessDocumentId) =>
  axios({
    url: `process/document/copy/${processId}/${documentTypeId}/${documentModelId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const cloneGDocModel = (documentModelId: string) =>
  axios({
    url: `process/document/model/copy/${documentModelId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const createModel = ({
  id,
  name,
  documentType,
  all_parts,
  parts,
  gdocsId
}: ICreateDocument) =>
  axios({
    url: `process/document/models/create`,
    method: "POST",
    data: {
      id,
      name,
      document_type: documentType,
      all_parts,
      parts,
      gdocs_id: gdocsId
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const editModel = ({
  id,
  name,
  documentType,
  all_parts,
  parts,
  gdocsId
}: ICreateDocument) =>
  axios({
    url: `process/document/models/edit/${id}`,
    method: "PUT",
    data: {
      name,
      document_type: documentType,
      all_parts,
      parts,
      gdocs_id: gdocsId
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const deleteModel = (modelId: string) =>
  axios({
    url: `process/document/models/delete/${modelId}`,
    method: "DELETE"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getAllModelList = (edit = true) =>
  axios({
    url: `process/document/models/list/`,
    method: "GET",
    params: { edit }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getModelsListByType = ({
  documentTypeId,
  isEditable
}: IProcessDocumentTypeId) =>
  axios({
    url: `process/document/models/list/${documentTypeId}/`,
    method: "GET",
    params: {
      edit: isEditable
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getGdocDocumentAndModels = ({
  processId,
  documentType
}: IProcessDocumentType) =>
  axios({
    url: `process/document/models/${processId}/${documentType}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getModelById = (modelId: number, edit: boolean) =>
  axios({
    url: `process/document/models/${modelId}/`,
    method: "GET",
    params: { edit }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });
